export enum FormReportTypes {
	GET_FORM = 'GET_FORM',
}

export interface IFormReportAction {
	type: typeof FormReportTypes.GET_FORM;
}

export type FormReportAction = IFormReportAction;
